export default __webpack_public_path__ + "static/media/pw-templates-edit.da652285.jpg";